module.exports = __webpack_public_path__ + "img/art-44.136d9dd5.png";